import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useControlledState } from '@react-stately/utils';
import { useMemo } from 'react';
import { useListState } from 'react-stately';
import { selectedKeyToNode } from '../../collections/aria/collection.esm.js';

function useSelectListState(props) {
  var _props$defaultSelecte;
  var _useControlledState = useControlledState(props.selectedKey, (_props$defaultSelecte = props.defaultSelectedKey) !== null && _props$defaultSelecte !== void 0 ? _props$defaultSelecte : null, props.onSelectionChange),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    selectedKey = _useControlledState2[0],
    setSelectedKey = _useControlledState2[1];
  var selectedKeys = useMemo(function () {
    return selectedKey != null && !Array.isArray(selectedKey) ? [selectedKey] : selectedKey || undefined;
  }, [selectedKey]);
  var _useListState = useListState(_objectSpread2(_objectSpread2({}, props), {}, {
      selectionMode: props.multiple ? 'multiple' : 'single',
      disallowEmptySelection: false,
      allowDuplicateSelectionEvents: true,
      selectedKeys: selectedKeys,
      onSelectionChange: function onSelectionChange(keys) {
        var _selection$;
        var selection = typeof keys !== 'string' ? Array.from(keys.values()) : [];
        var key = props.multiple ? selection : (_selection$ = selection[0]) !== null && _selection$ !== void 0 ? _selection$ : null;

        // Always fire onSelectionChange, even if the key is the same
        // as the current key (useControlledState does not).
        if (key === selectedKey && props.onSelectionChange) {
          props.onSelectionChange(key);
        } else if (selectedKey && props.onSelectionChange) {
          props.onSelectionChange(selectedKey);
        }
        setSelectedKey(key || selectedKey);
      }
    })),
    collection = _useListState.collection,
    disabledKeys = _useListState.disabledKeys,
    selectionManager = _useListState.selectionManager;
  var selectedItem = selectedKeyToNode(selectedKey, collection);
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: selectionManager,
    selectedKey: selectedKey,
    setSelectedKey: setSelectedKey,
    selectedItem: selectedItem
  };
}

export { useSelectListState };
//# sourceMappingURL=use-select-list-state.esm.js.map
